import React from "react";
import { articleData } from "../constants";
import { ShortDate } from "./smComponents/ShortDate";
import { Pagination } from "./smComponents/Pagination";
import PropTypes from "prop-types";
export const ArticlesSection = () => {
  return (
    <div className="max-width">
      <div className="wr-cg-4 mw-ct">
        {articleData.map(({ id, title, isPrimerEquipo }) => {
          return (
            <div className="arti-card" key={id}>
              <div className="cgi-8">
                <span className={`arti${id}`}></span>
              </div>
              <div className="card-body">
                <ShortDate isPrimerEquipo={isPrimerEquipo} />
                <h3 className="article-heading">{title}</h3>
              </div>
            </div>
          );
        })}
      </div>
      <Pagination />
    </div>
  );
};

ArticlesSection.propTypes = {
  isPrimerEquipo: PropTypes.bool
};
